<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li> {{ $t('general.automatic_competency_definitions') }} </li>
          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span> {{ $t('general.automatic_competency_definitions') }} ({{ items.total }}) </span>
          </h2>
        </div>
        <div class="section-header-right">
          <router-link v-if="$hasPermission('create_automaticcompetency')" :to="{ name: 'add.automatic.competency' }">
            <button aria-expanded="false" class="btn btn-default" type="button">
              <i class="uil-location-arrow"></i> {{ $t('general.define_new_auto_competencies') }}
            </button>
          </router-link>

          <button v-else aria-expanded="false" class="btn btn-default" type="button" disabled
            :style="{ cursor: 'not-allowed' }" :uk-tooltip="$t('general.no_permission')">
            <i class="uil-location-arrow"></i> {{ $t('general.define_new_auto_competencies') }}
          </button>
        </div>

      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between">

            <div class="uk-search uk-search-navbar">
              <i class="uil-search position-absolute"></i>

              <input v-model="filter.search" :placeholder="$t('general.search')"
                class="uk-search-input shadow-0 uk-form-small" type="search" />
            </div>
            <div class="d-flex">
              <sort-dropdown :sort-options="sortOption" :title="sortTitle" @sort-selected="sortOrder" />
            </div>
          </div>
        </div>

        <!-- Table -->
        <template>
          <div v-if="programs_loading" class="">
            <default-loading></default-loading>
          </div>
          <div v-else class="table-responsive">
            <table class="table align-items-center">
              <thead>
                <tr>
                  <th scope="col">{{ $t('general.auto_competency_identification_name') }}</th>
                  <th scope="col">{{ $t("general.added_at") }}</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody class="list">
                <!--user item-->
                <tr v-for="item in formattedItems">
                  <td>
                    {{ item.name }}
                  </td>
                  <td>{{ item.created_at }}</td>
                  <td class="text-right">
                    <div class="actions ml-3">
                      <router-link :to="{
                        name: 'edit.automatic.competency',
                        params: { id: item.id },
                      }" :uk-tooltip="$t('faq_categories.edit')" class="btn btn-icon btn-hover btn-sm btn-circle">
                        <i class="uil-edit "></i>
                      </router-link>
                      <a aria-expanded="false" class="btn btn-icon btn-hover btn-sm btn-circle" href="javascript:void(0)"
                        :uk-tooltip="!$hasPermission('delete_automaticcompetency') ? $t('general.no_permission') : $t('general.delete')"
                        @click="$hasPermission('delete_automaticcompetency') && removeItem(item.id)" :style="{
                          cursor: $hasPermission('delete_automaticcompetency') ? 'pointer' : 'not-allowed',
                          pointerEvents: $hasPermission('delete_automaticcompetency') ? 'auto' : 'none'
                        }">
                        <i class="uil-minus-circle text-danger"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination v-if="pagination && pagination.hasOwnProperty('links')" :pagination="pagination"
            @changePage="setPage($event)"></pagination>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable.vue";
import store from "@/core/services";
import Pagination from "@/assets/components/Pagination.vue";
import DefaultLoading from "@/view/components/loading/DefaultLoading.vue";

import module, {
  MODULE_NAME,
  ERROR,
  ITEMS,
  GET_ITEMS,
  DELETE_ITEM,
  LOADING
} from "@/core/services/store/assignment.module";
import moment from "moment";

import { confirmDialogDelete } from "@/utils/confirmDialog";
import SortDropdown from "@/view/components/dropdown/SortDropdown.vue";

export default {
  name: "AssignmentAuto",
  components: { SortDropdown, DataTable, Pagination, DefaultLoading },
  data() {
    return {
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      sortTitle: this.$t("filters.order.sort"),
      sortOption: [
        { key: 'text-asc', sort: 'asc', order: 'id', label: this.$t("sorting.a_z") },
        { key: 'text-desc', sort: 'desc', order: 'id', label: this.$t("sorting.z_a") },
        { key: 'created_at-asc', sort: 'asc', order: 'created_at', label: this.$t("sorting.created_at_asc") },
        { key: 'created_at-desc', sort: 'desc', order: 'created_at', label: this.$t("sorting.created_at_desc") },
      ],
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, module);
  },
  computed: {
    items: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    programs_loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    assignment_loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    formattedItems() {
      let results = [];
      if (this.items === null || this.items.length === 0) return [];
      this.pagination = this.items;

      this.items.data.forEach((currentItem) => {
        results.push({
          id: currentItem.id,
          name: currentItem.name,
          description: currentItem.description ? currentItem.description : "-",
          total_section: currentItem.sections_count,
          total_content: currentItem.contents_count,
          created_at: currentItem.created_at
            ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
            : "-",
        });
      });

      return results;
    },
  },
  methods: {
    getResult() {
      let self = this;
      // UIkit.dropdown("#sortDropDown").hide();
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: 'api/automatic-competencies',
        filters: {
          like: self.filter.search,
          page: self.page,
          perPage: self.per_page,
          sort: self.filter.sort,
          order: self.filter.order,
        },
      });
    },
    async removeItem(id) {
      const isConfirmed = await confirmDialogDelete({ context: this });

      if (isConfirmed) {
        this.$store
          .dispatch(MODULE_NAME + "/" + DELETE_ITEM, {
            url: 'api/automatic-competencies/' + id,
          })
          .then(() => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_deleted");
              this.getResult();
            } else this.errorMessages.push(this.error);
          });
      }
    },
    sortOrder({ sort, order }) {
      let self = this;
      self.page = 1;
      self.filter.sort = sort;
      self.filter.order = order;

      this.getResult();
    },
    setPage(page, is_user = true) {
      let self = this;
      self.page = page;
      this.getResult();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    this.getResult();
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.assignment-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.assignment-order {
  font-size: 12px;
  color: rgb(149, 149, 149);
}
</style>
